import React, { useState, useMemo } from 'react';
import NextLink from 'next/link';
import clsx from 'clsx';
import { addCanalPlusGTMClass, formatCategoryUrl } from 'services/lib/util';

const RecursiveMenuItem = ({ item, depth = 0, onChildClick }) => {
  const [isHovered, setIsHovered] = useState(false);

  const hasChildren = item.children && item.children.length > 0;
  const isTopLevel = depth === 0;

  // REAKCJA NA STRUKTURĘ: Szukamy, czy istnieje poziom depth-2 (wnuki)
  const hasGrandchildren = useMemo(() => {
    if (!isTopLevel || !hasChildren) return false;

    // Sprawdzamy, czy któregokolwiek z dzieci (depth-1) posiada swoje dzieci (depth-2)
    return item.children.some((child) => child.children && child.children.length > 0);
  }, [item.children, isTopLevel, hasChildren]);

  const handleItemClick = () => {
    setIsHovered(false);
    if (onChildClick) {
      onChildClick();
    }
  };

  return (
    <li
      className={clsx(
        `depth-${depth}`,
        hasChildren && 'has-children',
        // Warunek 1: Element najwyższego rzędu i struktura ma 3 poziomy (posiada wnuki) -> MEGA MENU
        isTopLevel && hasGrandchildren && 'is-mega-menu',
        // Warunek 2: Element najwyższego rzędu i struktura ma 2 poziomy (posiada tylko dzieci) -> STARA PREZENTACJA
        isTopLevel && hasChildren && !hasGrandchildren && 'is-standard-dropdown',
        isHovered && 'is-active-hover',
      )}
      onMouseEnter={() => isTopLevel && setIsHovered(true)}
      onMouseLeave={() => isTopLevel && setIsHovered(false)}
    >
      <NextLink
        href={formatCategoryUrl(item.path)}
        passHref
        onClick={handleItemClick}
        className={clsx('header-menu-item', depth > 0 && 'header-submenu-item', addCanalPlusGTMClass(item.path))}
      >
        {item.label}
      </NextLink>

      {hasChildren && (
        <ul className="children">
          {item.children.map((child) => (
            <RecursiveMenuItem key={child.id} item={child} depth={depth + 1} onChildClick={handleItemClick} />
          ))}
        </ul>
      )}
    </li>
  );
};

export default RecursiveMenuItem;
